// src/components/ToastContainer.js
import React, { createContext, useContext, useState, useCallback } from "react";
import Toast from "./Toast";
import "./ToastContainer.css";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  // const [toasts, setToasts] = useState([]);
  const [toast, setToast] = useState(null);

  // const addToast = useCallback(
  //   (title, message, type, buttonText, buttonClick, duration) => {
  //     const id = Math.random().toString(36).substr(2, 9);
  //     setToasts((prevToasts) => [
  //       ...prevToasts,
  //       { id, title, message, type, buttonText, buttonClick, duration },
  //     ]);
  //   },
  //   []
  // );

  // const removeToast = useCallback((id) => {
  //   setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  // }, []);
  const addToast = useCallback(
    (
      title,
      message,
      type,
      buttonText,
      buttonClick,
      secondaryButtonText,
      secondaryButtonClick,
      duration
    ) => {
      const id = Math.random().toString(36).substr(2, 9);

      // Set the new toast, replacing any existing one
      setToast({
        id,
        title,
        message,
        type,
        buttonText,
        buttonClick,
        secondaryButtonText,
        secondaryButtonClick,
        duration,
      });

      // Automatically remove the toast after its duration
      // setTimeout(() => {
      //   removeToast();
      // }, duration || 5000); // Default to 5 seconds if no duration specified
    },
    []
  );

  const removeToast = useCallback(() => {
    setToast(null);
  }, []);

  return (
    <ToastContext.Provider value={addToast}>
      <div className="toast-container">
        {/* {toast.map((toast) => (
          <Toast
            key={toast.id}
            id={toast.id}
            title={toast.title}
            message={toast.message}
            type={toast.type}
            buttonText={toast.buttonText}
            buttonClick={toast.buttonClick}
            duration={toast.duration}
            onClose={removeToast}
          />
        ))} */}
        {toast && (
          <Toast
            key={toast.id}
            id={toast.id}
            title={toast.title}
            message={toast.message}
            type={toast.type}
            buttonText={toast.buttonText}
            buttonClick={toast.buttonClick}
            duration={toast.duration}
            secondaryButtonClick={toast.secondaryButtonClick}
            secondaryButtonText={toast.secondaryButtonText}
            onClose={removeToast}
          />
        )}
      </div>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
